/* eslint-disable global-require */
const List = () => import('./main.vue');

export default [
  {
    name: 'exportacao/contas-pagar',
    path: '/exportacao/contas-pagar',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Contas Pagar',
      icon: 'file-invoice-dollar',
      can: 'list',
      on: 'contaspagar',
      bisneto: true,
    },
  },
];
